import HeaderWrapper from '../components/Header/HeaderWrapper';
import Logo from '../components/Header/Logo';
import Navbar from '../components/Header/Navbar';
import FooterCompound from '../compounds/FooterCompound';


const PrivacyPage = () => {
  // Define the inline style
  const privacyPolicyStyle = {
    margin: '20px',
    padding: '20px',
    backgroundColor: '#000',
    borderRadius: '10px',
    lineHeight: '1.6',
    fontFamily: 'Arial, sans-serif',
    fontSize: '14px'
  };

  return (
    <>
      <HeaderWrapper>
        <Navbar>
          <Logo />
        </Navbar>
        <h1>OUAlumni.org Privacy and Policy</h1>
        <div style={privacyPolicyStyle}>
          <h2>We Care About yOUr Privacy</h2>
          <p className="effective-date">Effective Date: 12/25/2023</p>
          <p>Welcome to OUAlumni.org (“OUA”, “we”, “us”, “our”). This Privacy Policy outlines our practices regarding the collection, use, and sharing of your information through our website, mobile applications, and services (collectively, the “Services”).</p>
          
          <h3>1. Information Collection</h3>
          <p>When you use our Services, we collect the following information:</p>
          <ul>
            <li>Personal Information: This includes your name, email address, and avatar profile photo. You may also choose to write a bio and add a YouTube video about yourself. You can add traits about your past college life at OU and also your current life.</li>
          </ul>

          <h3>2. Use of Information</h3>
          <p>Your information is used to:</p>
          <ul>
            <li>Match you to others with similar traits and interests.</li>
            <li>Provide, maintain, and improve our Services.</li>
            <li>Display your profile in member directories and search.</li>
            <li>Conduct internal analytics to enhance user experience.</li>
            <li>With your permission, share aggregate data slices with trusted third-party partners for research and analysis.</li>
          </ul>

          <h3>3. Data Sharing and Third-Party Partnerships</h3>
          <p>We do not share your email address with third parties. Aggregate data about user interactions with colleges or states may be shared for demographic analysis. Details of third-party partners and the nature of data shared will be transparently listed on our website.</p>

          <h3>4. User Consent and Control</h3>
          <p>By using our Services and agreeing to this Privacy Policy, you consent to the collection, use, and sharing of your information as described. You control your visibility settings and can opt-in for data sharing with third-party partners. All profiles are subject to this Privacy Policy.</p>

          <h3>5. Security and Data Protection</h3>
          <p>We employ standard hosting security on DigitalOcean.com, Laravel, and MySQL security practices, including SSL encryption. Regular security audits are conducted, and AI technology is used to identify and address vulnerabilities. We strive to provide robust data protection within our startup resources.</p>

          <h3>6. Changes to This Policy</h3>
          <p>We may update this Privacy Policy periodically. The effective date at the top will indicate when it was last revised.</p>

          <h3>7. Contact Us</h3>
          <p>For questions about this Privacy Policy, please contact us at support@oualumni.org.</p>

          <h3>8. Agreement</h3>
          <p>By using our Services, you acknowledge that you have read and understood this Privacy Policy and agree to be bound by it.</p>

          <h2>Terms:</h2>
          <p>OUAlumni.org Terms and Conditions of Use: We reserve the right to change this policy at any given time, of which you will be promptly updated. If you want to make sure that you are up to date with the latest changes, we advise you to frequently visit this page.</p>

          <h3>User Data We Collect:</h3>
          <p>When you visit any view or page from the RMC platform, we may collect the following data:</p>
          <ul>
            <li>Your IP address</li>
            <li>Your contact information, such as email address</li>
            <li>Your LinkedIn website</li>
            <li>Traits about your past college life at OU and also your current life.</li>
          </ul>

          <p>We are collecting your data for several reasons:</p>
          <ul>
            <li>To better understand the needs of users.</li>
            <li>To provide a platform for conversation.</li>
            <li>To improve our services and products over time based on user behavior.</li>
            <li>To send you promotional emails containing information we think you will find interesting and valuable.</li>
            <li>To contact you to fill out surveys and participate in other types of market research regarding higher education preferences.</li>
            <li>To deliver a truly customized OUAlumni platform according to your online behavior and personal preferences.</li>
          </ul>

          <h3>Safeguarding and Securing Your Data:</h3>
          <p>OUA is committed to securing your data and keeping it confidential. Rank My Colleges maintains high quality security standards for all interactions within the OUA database and access points to RMC data, which help to prevent data theft, unauthorized access, and disclosure, and to safeguard all the information we collect online.</p>
          <p>The data we collect by using cookies is used to customize our platform to your needs. After we use the data for statistical analysis, the data is completely removed from our systems.</p>
          <p>Please note that cookies do not allow us to gain control of your computer in any way. They are strictly used to monitor which pages you find useful and which you do not so that we can provide a better experience for you.</p>
          <p>If you want to disable cookies, you can do it by accessing the settings of your internet browser. You can visit www.internetcookies.com, which contains comprehensive information on how to do this on a wide variety of browsers and devices.</p>

          <h3>Links to Other Online Properties:</h3>
          <p>Our website and platform access points contain links that lead to other online properties. If you click on these links, OUA is not held responsible for your data and privacy protection. Visiting those websites is not governed by this privacy policy agreement. Make sure to read the privacy policy documentation of the website or app you go to from the OUA platform.</p>

          <h3>Restricting the Collection of Your Personal Data:</h3>
          <p>Your personal information will be used when we need to send you promotional materials if you agree to this privacy policy.</p>
        </div>
      </HeaderWrapper>
      <FooterCompound />
    </>
  );
};

export default PrivacyPage;

